<template>
  <div>
    <div class="overview-box">
      <div class="title">红包发放数据</div>
      <div class="flex flex-center mt20">
        <div
          class="flex-1 flex purchase-data p10 pointer"
          :class="{ mr20: i < redList.length - 1 }"
          v-for="(v, i) in redList"
          :key="i"
        >
          <div class="hm-icon mr10">
            <span class="hmicon" :class="v.icon"></span>
          </div>
          <div class="flex-1">
            <p class="purchase-name mt10">
              {{ v.name }}
            </p>
            <div class="mt10 flex flex-between item-center">
              <div class="purchase-val">
                {{ i != 1 && i != 3 ? "¥" : "" }} {{ v.val }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hm-content title="">
      <div class="table-panel flex flex-end">
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.keyWord"
          placeholder="请输入名称/手机号"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
      <el-table :data="list" style="width: 100%" stripe border size="small">
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiveTime"
          label="发放时间"
          width="160"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareRewardMoney"
          label="邀请者奖励金额"
        >
        <template slot-scope="scope">
          {{ToFixed(scope.row.shareRewardMoney,2)}}
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiveRewardMoney"
          label="被邀请者奖励金额"
        >
         <template slot-scope="scope">
          {{ToFixed(scope.row.receiveRewardMoney,2)}}
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareMemberName"
          label="邀请者名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareMemberMobile"
          label="邀请者手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiveMemberName"
          label="被邀请者名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiveMemberMobile"
          label="被邀请者手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="gameType"
          label="活动类型"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.spreadTarget == 'guider'"
              >导购邀请供应商奖励活动</span
            >
            <span v-else-if="scope.row.spreadTarget == 'supplier'"
              >业务员邀请供应商奖励活动</span
            >
            <span v-else-if="scope.row.spreadTarget == 'store'"
              >采购邀请供应商奖励活动</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spreadName"
          label="活动名称"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </hm-content>
  </div>
</template>

<script>
import { ToFixed } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      ToFixed,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchCondition: {},
      redList: [
        {
          icon: "icon-tongzhirenshu1",
          name: "今日红包发放金额",
          val: 0,
          pathName: "AfterPurchaseOrder",
          type: "today"
        },
        {
          icon: "icon-tongzhirenshu1",
          name: "今日红包发放数量",
          val: 0,
          pathName: "AfterPurchaseOrder",
          type: "yesterday",
          oldValue: 0
        },
        {
          icon: "icon-tongzhirenshu1",
          name: "红包发放总金额 ",
          val: 0,
          pathName: "PotentialGoods",
          type: "",
          tip: "自动为您挑选出复购概率较大的商品"
        },
        {
          icon: "icon-tongzhirenshu1",
          name: "红包发放总数量",
          val: 0,
          pathName: "PurchaseMsgPush",
          type: "",
          oldValue: 0
        }
      ]
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "redpackageSpreadStatistic",
        params
      );

      if (code === "0") {
        const { SendDataInfoList, redpackageSendInfo } = result;
        this.redList[0].val = ToFixed(redpackageSendInfo.sendMoneyToday, 2);
        this.redList[1].val = redpackageSendInfo.sendCountToday;
        this.redList[2].val = ToFixed(redpackageSendInfo.sendMoneyTotal, 2);
        this.redList[3].val = redpackageSendInfo.sendCountTotal;
        const { records, total } = SendDataInfoList;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang='scss' scoped>
.overview-box {
  background: #ffffff;
  margin-bottom: 10px;
  padding: 20px;
  .title {
    color: #222222;
    font-weight: bold;
    &::before {
      display: inline-block;
      margin-right: 5px;
      content: "";
      width: 4px;
      height: 14px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.purchase-data {
  box-shadow: 0px 0px 18px 0px rgba(221, 221, 221, 0.39);
  border-radius: 6px;
  .hm-icon {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    text-align: center;
    line-height: 66px;
    background: #feeef5;
    margin-left: 40px;
    .hmicon {
      font-size: 25px;
      color: #e50065;
    }
  }
  .purchase-name {
    color: #222222;
    font-size: 14px;
  }
  .purchase-val {
    font-size: 24px;
    font-weight: bold;
  }
}
</style>
